var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ev-hotspots"},_vm._l((_vm.hotspots),function(hotspot){return _c('GalleryHotspot',{key:hotspot.id,attrs:{"hotspot":hotspot}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }